export const leftTdProps = {
  textAlign: 'left',
  display: 'inline-flex',
  alignItems: 'center',
  marginRight: 4,
}

export const rightTdProps = {
  textAlign: 'left',
}
